module.exports = __webpack_public_path__ + "img/bg_index@2x.cb1698ac.jpg";